/**
 * Bin types, recognised from whatever the Kommune felt like writing.
 *
 * Titles vary wildly between authorities — "Biotonne", "Leerung
 * Restabfallbehälter 240l", "Abfuhr: Gelber Sack", "Papier/Pappe" — so this is
 * keyword matching over free text, not a lookup.
 */
export const wasteTypes = ['rest', 'bio', 'papier', 'gelb', 'glas', 'sperr', 'baum', 'other'];
const KINDS = {
    rest: { type: 'rest', label: 'Restmüll', colour: 'oklch(0.62 0.012 60)' },
    bio: { type: 'bio', label: 'Biotonne', colour: 'oklch(0.55 0.09 60)' },
    papier: { type: 'papier', label: 'Papier', colour: 'oklch(0.62 0.13 245)' },
    gelb: { type: 'gelb', label: 'Gelber Sack', colour: 'oklch(0.82 0.15 95)' },
    glas: { type: 'glas', label: 'Glas', colour: 'oklch(0.68 0.11 165)' },
    sperr: { type: 'sperr', label: 'Sperrmüll', colour: 'oklch(0.66 0.13 320)' },
    baum: { type: 'baum', label: 'Weihnachtsbaum', colour: 'oklch(0.70 0.13 145)' },
    other: { type: 'other', label: 'Abfuhr', colour: 'oklch(0.70 0.02 70)' },
};
/**
 * Ordered because titles overlap: "Restabfall" and "Bioabfall" both contain
 * "abfall", and "Altpapier" must not be caught by a bare "papier" rule placed
 * after something broader. First match wins, so the specific patterns lead.
 */
/**
 * Patterns tolerate both umlaut spellings: folding turns "Sperrmüll" into
 * "sperrmull", but plenty of authorities type "Sperrmuell" instead, and that
 * survives folding untouched. Hence the optional `e` after folded umlauts.
 */
const RULES = [
    { type: 'baum', pattern: /weihnachtsbaum|tannenbaum|christbaum/ },
    { type: 'sperr', pattern: /sperr|grossgera?e?t|elektro/ },
    { type: 'bio', pattern: /bio|kompost|gru?e?ngut|gru?e?nabfall|gartenabfall|laub/ },
    { type: 'papier', pattern: /papier|pappe|karton|blaue? tonne/ },
    { type: 'gelb', pattern: /gelb|verpackung|wertstoff|lvp|plastik|leichtstoff|recycling/ },
    { type: 'glas', pattern: /glas/ },
    { type: 'rest', pattern: /rest|hausmue?ll|schwarze? tonne|graue? tonne|siedlungsabfall/ },
];
/** Lower case, umlauts folded — the same normalising the catalogue search uses. */
function fold(value) {
    return value
        .toLowerCase()
        .replace(/ß/g, 'ss')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '');
}
/**
 * Classify a collection event's title.
 *
 * Never returns null. An unrecognised title falls back to `other` and keeps
 * its original text — a bin missed because we did not know the word
 * "Restabfallbehälter" is far worse than an unstyled row.
 */
export function classifyWaste(title) {
    const folded = fold(title);
    for (const rule of RULES) {
        if (rule.pattern.test(folded))
            return KINDS[rule.type];
    }
    return KINDS.other;
}
export function wasteKind(type) {
    return KINDS[type];
}
